import { render, staticRenderFns } from "./MenuDiscount.vue?vue&type=template&id=6e2b91cc&scoped=true&"
import script from "./MenuDiscount.vue?vue&type=script&lang=js&"
export * from "./MenuDiscount.vue?vue&type=script&lang=js&"
import style0 from "./MenuDiscount.vue?vue&type=style&index=0&id=6e2b91cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b91cc",
  null
  
)

export default component.exports